<div *ngIf="loadingspinner == true" class="spin"></div>


<table class="table" style="background-color:white;">

  <tr>
    <td style="background-color:brown;color:white;" colspan="2">Forgot Password</td>
    <td style="text-align: right;background-color: brown;color: white;padding-right: 32px;"><mat-icon [mat-dialog-close]="false">close</mat-icon></td>
  </tr>
</table>
<p class="logo-title">You will receive an email with a code to reset your password</p>
<fieldset [disabled]="loadingspinner == true" [ngClass]="{'disabled':loadingspinner == true}">
  <form [formGroup]="forgetPasswordForm" (ngSubmit)="forgetPassword(forgetPasswordForm.value)">
    <div *ngIf="change==false">
      <mat-form-field class="col-lg-8">
        <input matInput placeholder="Email Id" formControlName="emailId" maxlength="100" required />
        <mat-error *ngIf="submitted && f.emailId.errors">
          Enter Valid Email Id
        </mat-error>
      </mat-form-field>
      <button type="button" mat-raised-button color="primary" class="commn-btn col-lg-3" style="margin-top: 20px;background-color:#f44a4a;color:white !important;" (click)="sendCode()">Send Code</button>


    </div>
    <div *ngIf="change==true">
      <mat-form-field class="col-lg-4">
        <input matInput placeholder="Verify Code" formControlName="verifyCode" NumberOnly maxlength="6" required />
        <mat-error *ngIf="submitted && f.verifyCode.errors">
          Enter Verify Code
        </mat-error>
      </mat-form-field>


      <mat-form-field class="col-lg-4">
        <input type="password" matInput placeholder="New Password" formControlName="newPassword" maxlength="20" minlength="8" required />
        <mat-error *ngIf="submitted && f.newPassword.errors?.required">
          Enter New Password
        </mat-error>
        <mat-error *ngIf="f.newPassword.hasError('pattern')">
          New Password must contain a minimum of 8 characters which should include 1 alpha numeric, 1 upper case letter, 1 lower case letter & 1 special character(eg:Ghan@233)
        </mat-error>
      </mat-form-field>

      <mat-form-field class="col-lg-4">
        <input type="password" matInput placeholder="Confirm Password" formControlName="confirmPassword" maxlength="20" minlength="8" required />
        <mat-error *ngIf="submitted && f.confirmPassword.errors?.required">
          Enter Confirm Password
        </mat-error>
        <mat-error *ngIf="f.confirmPassword.hasError('pattern')">
          Confirm Password must contain a minimum of 8 characters which should include 1 alpha numeric, 1 upper case letter, 1 lower case letter & 1 special character(eg:Ghan@233)
        </mat-error>
        <mat-error *ngIf="f.confirmPassword.hasError('confirmPasswordValidator')">Password and Confirm Password must be match</mat-error>

      </mat-form-field>


      <div style="display: flex;justify-content: center;align-items: center;">
        <button type="submit" mat-raised-button color="primary" class="commn-btn col-lg-3" style="margin-top: 20px;background-color:#f44a4a;color:white !important;">
          Submit
        </button>


      </div>
    </div>
  </form>

</fieldset>
